/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { readable_member } from '../models/readable_member';
import type { writtable_member } from '../models/writtable_member';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MemberService {
    /**
     * Create a C-wallet `Member`.
     *
     * @param member
     * @returns readable_member Successful operation, returning created member.
     * @throws ApiError
     */
    public static postMembers(
        member: writtable_member,
    ): CancelablePromise<readable_member> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/members',
            body: member,
        });
    }
    /**
     * Update C-wallet `Member` information.
     *
     * @param memberId Member identifier
     * @param member
     * @returns readable_member Successful operation, returning saved member.
     * @throws ApiError
     */
    public static patchMembers(
        memberId: number,
        member: writtable_member,
    ): CancelablePromise<readable_member> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/members/{member_id}',
            path: {
                'member_id': memberId,
            },
            body: member,
        });
    }
    /**
     * Retrieve a C-wallet `Member`.
     *
     * @param memberId Member identifier
     * @returns readable_member Successful response, returning found member.
     * @throws ApiError
     */
    public static getMembers(
        memberId: number,
    ): CancelablePromise<readable_member> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/members/{member_id}',
            path: {
                'member_id': memberId,
            },
        });
    }
    /**
     * Send `Member` delete request.
     *
     * @param memberId Member identifier
     * @param withAck Send email for suppression (default value : true)
     * @returns any Successful response, confirmation email has been sent.
     * @throws ApiError
     */
    public static deleteMembers(
        memberId: number,
        withAck?: boolean,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/members/{member_id}',
            path: {
                'member_id': memberId,
            },
            query: {
                'with_ack': withAck,
            },
        });
    }
    /**
     * Request `Member` reset password email.
     *
     * @param member
     * @returns any Successful operation, returning created member.
     * @throws ApiError
     */
    public static postMembersResetPassword(
        member: {
            /**
             * Member Email
             */
            email?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/members/reset_password',
            body: member,
        });
    }
}
